import { mapGetters } from 'vuex'

export const skillDiveLabsCommons = {
  data() {
    return {
      labContent: null,
      extraTag: null,
      extraTagTooltip: null,
      keyConceptList: [],
      skillDiveLabsCommonsLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      userAvailableLearningArea: 'labExperience/userAvailableLearningArea',
      isSkillDiveB2CUser: 'auth/isSkillDiveB2CUser',
      isAccOwnerOrTeamManager: 'auth/isAccOwnerOrTeamManager',
      isBusinessUser: 'business/isBusinessUser',
    }),
    skillDiveDescription() {
      return this.labContent.description_html || this.labContent.description
    },
    lockedContent() {
      const las = this.labContent?.learning_areas.map(la => la.name)
      return !this.userAvailableLearningArea.some(la => las?.includes(la.name))
    },
  },
  methods: {
    setSkillDiveTags() {
      let tags = []
      const count = 6
      if (this.labContent?.tags?.length) {
        tags = this.labContent.tags.slice(0, count)
      }

      if (this.labContent?.tags?.length > count) {
        this.extraTag = `+ ${this.labContent?.tags?.length - count}`
        this.extraTagTooltip = this.labContent?.tags
          .slice(count - 1, this.labContent?.tags?.length)
          .join('\r\n')
      }

      this.keyConceptList = tags
    },
    async getAccessToLockedSDLab() {
      if (this.lockedContent) {
        if (this.isSkillDiveB2CUser) {
          this.$router.push({
            name: 'user-dashboard',
            params: {
              mode: 'subscriptions',
            },
          })
        } else if (this.isBusinessUser && !this.isAccOwnerOrTeamManager) {
          if (!this.skillDiveLabsCommonsLoading) {
            this.skillDiveLabsCommonsLoading = true
            await this.requestAddonLicense('skill-dive')
            this.skillDiveLabsCommonsLoading = false
          }
        } else {
          window.location.href = this.isAccOwnerOrTeamManager
            ? this.skillDiveEngage
            : this.checkoutUrl
        }
      }
    },
  },
}
